import Header from './components/Header';
import Hero from './components/Hero';
import CardsSection from './components/CardsSection';
import TopicsSection from './components/TopicsSection';
import IndexSection from './components/IndexSection';
import FaqSection from './components/FaqSection';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import ContactSection from './components/ContactSection';
import CarouselSection from './components/CarouselSection';
import UpdatesSection from './components/UpdatesSection';
import AppSection from './components/AppSection';
import CommentsSection from './components/CommentsSection';
import AboutSection from './components/AboutSection';
import RankingSection from './components/RankingSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <CardsSection />
        <TopicsSection />
        <IndexSection />
        <FaqSection />
        <MediaSection />
        <FeaturesSection />
        <ContactSection />
        <CarouselSection />
        <UpdatesSection />
        <AppSection />
        <CommentsSection />
        <AboutSection />
        <RankingSection />
      </main>
      <Footer />
    </div>
  );
}